var lastArrayEach = require('./lastArrayEach')
var keys = require('./keys')

function lastObjectEach (obj, iterate, context) {
  lastArrayEach(keys(obj), function (key) {
    iterate.call(context, obj[key], key, obj)
  })
}

module.exports = lastObjectEach



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/lastObjectEach.js
// module id = s/GI
// module chunks = 141